import direct from '@/api/direct';

const APPEND_DIRECTS = 'APPEND_DIRECTS';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_IS_ALL = 'SET_IS_ALL';
const ADD_PAGE = 'ADD_PAGE';
const RESET_DIRECTS = 'RESET_DIRECTS';
const SET_PAGE_INFO = 'SET_PAGE_INFO';

const state = {
	all: [],
	isFetching: false,
	isAll: false,
	page: 1,
	isFetched: false,
	pageInfo: null,
};

const getters = {
	allDirects: state => state.all,
	isFetching: state => state.isFetching,
	isAll: state => state.isAll,
	page: state => state.page,
	isFetched: state => state.isFetched,
	pageInfo: state => state.pageInfo,
};

const mutations = {
	[APPEND_DIRECTS](state, directs) {
		state.all = state.all.concat(directs);
	},
	[RESET_DIRECTS](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_IS_ALL](state, status) {
		state.isAll = status;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_PAGE_INFO](state, pageInfo) {
		state.pageInfo = pageInfo;
	},
};

const actions = {
	getDirects({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				console.log(response);
				const directs = response.data.directs ? response.data.directs : response.data;
				if (response.data.page_info) {
					const pageInfo = response.data.page_info;
					commit(SET_PAGE_INFO, pageInfo);
				}
				if (directs.length !== 0) {
					commit(APPEND_DIRECTS, directs);
					commit(ADD_PAGE);
				} else {
					commit(SET_IS_ALL, true);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHED, true);
			};
			direct.getDirects(params, callback, errorCallback);
		}
	},
	resetDirects({ commit }) {
		commit(RESET_DIRECTS);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
